import axios from "axios";

export const API_BASE = process.env.REACT_APP_API_URL || "";
const API_URL  = API_BASE.replace(/\/api\/?$/, "") + "/api";

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) =>
  api.post("/auth/token", new URLSearchParams({ username: email, password }));
export const getMe = () => api.get("/auth/me");

// Clientes
export const getClientes = (q) => api.get("/clientes", { params: { q } });
export const createCliente = (d) => api.post("/clientes", d);
export const updateCliente = (id, d) => api.put(`/clientes/${id}`, d);
export const deleteCliente = (id) => api.delete(`/clientes/${id}`);

// Vehiculos
export const getVehiculos = (params) => api.get("/vehiculos", { params });
export const createVehiculo = (d) => api.post("/vehiculos", d);
export const updateVehiculo = (id, d) => api.put(`/vehiculos/${id}`, d);

// Aseguradoras
export const getAseguradoras = () => api.get("/aseguradoras");
export const createAseguradora = (d) => api.post("/aseguradoras", d);
export const updateAseguradora = (id, d) => api.put(`/aseguradoras/${id}`, d);
export const deleteAseguradora = (id) => api.delete(`/aseguradoras/${id}`);

// Tecnicos
export const getTecnicos = () => api.get("/tecnicos");
export const createTecnico = (d) => api.post("/tecnicos", d);
export const updateTecnico = (id, d) => api.put(`/tecnicos/${id}`, d);
export const deleteTecnico = (id) => api.delete(`/tecnicos/${id}`);

// Funcionarios
export const getFuncionarios = () => api.get("/funcionarios");
export const createFuncionario = (d) => api.post("/funcionarios", d);
export const updateFuncionario = (id, d) => api.put(`/funcionarios/${id}`, d);
export const deleteFuncionario = (id) => api.delete(`/funcionarios/${id}`);

// Proveedores
export const getProveedores = () => api.get("/proveedores");
export const createProveedor = (d) => api.post("/proveedores", d);
export const updateProveedor = (id, d) => api.put(`/proveedores/${id}`, d);
export const deleteProveedor = (id) => api.delete(`/proveedores/${id}`);

// Repuestos
export const getRepuestos = (params) => api.get("/repuestos", { params });
export const createRepuesto = (d) => api.post("/repuestos", d);
export const updateRepuesto = (id, d) => api.put(`/repuestos/${id}`, d);
export const deleteRepuesto = (id) => api.delete(`/repuestos/${id}`);
export const addMovimiento = (id, d) => api.post(`/repuestos/${id}/movimiento`, d);
export const getMovimientos = (id) => api.get(`/repuestos/${id}/movimientos`);

// Recepciones
export const getRecepciones = (params) => api.get("/recepciones", { params });
export const createRecepcion = (d) => api.post("/recepciones", d);
export const getRecepcion = (id) => api.get(`/recepciones/${id}`);
export const updateRecepcion = (id, d) => api.put(`/recepciones/${id}`, d);

// Presupuestos
export const getPresupuestos = (params) => api.get("/presupuestos", { params });
export const createPresupuesto = (d) => api.post("/presupuestos", d);
export const getPresupuesto = (id) => api.get(`/presupuestos/${id}`);
export const updatePresupuesto = (id, d) => api.put(`/presupuestos/${id}`, d);
export const cambiarEstadoPresupuesto = (id, estado) =>
  api.patch(`/presupuestos/${id}/estado`, null, { params: { estado } });

// Órdenes
export const getOrdenes = (params) => api.get("/ordenes", { params });
export const createOrden = (d) => api.post("/ordenes", d);
export const getOrden = (id) => api.get(`/ordenes/${id}`);
export const updateOrden = (id, d) => api.put(`/ordenes/${id}`, d);
export const cambiarEstadoOrden = (id, estado) =>
  api.patch(`/ordenes/${id}/estado`, null, { params: { estado } });

// Facturas
export const getFacturas = (params) => api.get("/facturas", { params });
export const createFactura = (d) => api.post("/facturas", d);
export const getFactura = (id) => api.get(`/facturas/${id}`);
export const pagarFactura = (id, forma_pago) =>
  api.patch(`/facturas/${id}/pagar`, null, { params: { forma_pago } });
export const anularFactura = (id) => api.patch(`/facturas/${id}/anular`);

// Gastos
export const getGastos = (params) => api.get("/gastos", { params });
export const createGasto = (d) => api.post("/gastos", d);
export const updateGasto = (id, d) => api.put(`/gastos/${id}`, d);
export const deleteGasto = (id) => api.delete(`/gastos/${id}`);

// Dashboard
export const getDashboardKpis = () => api.get("/dashboard/kpis");
export const getTrabajosPorEstado = () => api.get("/dashboard/trabajos-por-estado");
export const getIngresosMensuales = () => api.get("/dashboard/ingresos-mensuales");
export const getUrgentes = () => api.get("/dashboard/urgentes");
export const getUsuarios = () => api.get("/dashboard/usuarios");
export const createUsuario = (d) => api.post("/dashboard/usuarios", d);
export const updateUsuario = (id, d) => api.put(`/dashboard/usuarios/${id}`, d);

// Reportes
export const getReporteTrabajos = (params) => api.get("/reportes/trabajos", { params });
export const getTecnicosProductividad = () => api.get("/reportes/tecnicos-productividad");

// Empresa
export const getEmpresa = () => api.get("/empresa");
export const updateEmpresa = (d) => api.put("/empresa", d);
export const uploadLogoEmpresa = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/empresa/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
};

export default api;
